import React from "react";
import { connectWithLifecycle } from "react-lifecycle-component";
// import { List } from "material-ui/List";
import Subheader from "material-ui/Subheader";
import OrderLineListItem from "../presentational/OrderLineListItem2";
import { filterDeliveredOrderLines } from "../../redux/modules/uiDuck";
import { setOrderLineStatus } from "../../redux/modules/ordersDuck";
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { viewOrder } from "../../redux/modules/ordersDuck";
import { getShowUndeliveredOrderLines, getTeamNameById } from "../../redux/selectors";
import { push } from "react-router-redux";
import moment from "moment";

const mapStateToProps = state => {
  return {
    orders: state.getIn(["ordersStore", "orders"]),
    showUndeliveredOrderLines: getShowUndeliveredOrderLines(state),
    teamById: getTeamNameById(state),
  };
};

const mapDispatchToProps = dispatch => ({
  handleSwitchFilter: (event, isInputChecked) => {
    dispatch(filterDeliveredOrderLines(isInputChecked));
  },
  handleViewOrder: orderId => {
    dispatch(viewOrder(orderId));
    dispatch(push("order/" + orderId + "/view"));
  },
  handleSwitchLineStatus: (orderId, lineId, newStatus) => {
    // console.log("handleSwitchLineStatus", orderId, lineId, newStatus);
    dispatch(setOrderLineStatus(orderId, lineId, newStatus));
  }
});

const sortOrderByCreationDateDesc = (a, b) =>
  moment(a.get("createdAt")).isBefore(b.get("createdAt")) ? -1 : 1;

export const PendingOrderLines = ({
  orders,
  handleViewOrder,
  handleSwitchFilter,
  showUndeliveredOrderLines,
  handleSwitchLineStatus,
  teamById,
}) => {
  const unfilteredOLines = orders
    .filter(o => !o.get("delivered"))
    .sort(sortOrderByCreationDateDesc)
    .map(o =>
      o
        .get("orderLines")
        .map(ol => ol.set("orderId", o.get("id")))
        .map(ol => ol.set("orderDelivered", o.get("delivered")))
        .map(ol => ol.set("orderPaid", o.get("paid")))
        .map(ol => ol.set("customerTeam", o.getIn(["team", "id"])))
        .map(ol => ol.set("customerName", o.get("customerName")))
    )
    .flatten(1)
    .toJS();

  const filterList = status => oLines => (
    oLines
    ? oLines
      .filter(orderLine => orderLine.status === status)
      .map((orderLine, index) => {
        return (
          <OrderLineListItem
            key={index}
            index={index}
            client={"client"}
            orderId={orderLine.orderId}
            orderLine={orderLine}
            showQuantity={true}
            customerName={orderLine.customerName}
            customerTeam={orderLine.customerTeam}
            getTeamById={teamById}
          />
        );
      })
    : <div />
  );

  const containerStyle = {
    border: '1px solid lightgrey',
    margin: 5,
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '110px',
    flex: '1 1 0',
  }

  const listStyle = {
    transition: 'background-color 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 100,
  }

  const column = state => items => 
  <div className="container" style={containerStyle}>
    <Subheader>{state}</Subheader>
    <Droppable droppableId={state}>
      {(provided, snapshot) => (
        <div className="cardlist"
          ref={provided.innerRef}
          style={{
            ...listStyle,
            backgroundColor: snapshot.isDraggingOver ? 'skyblue' : ''
          }}
          {...provided.droppableProps}
        >
          {filterList(state)(items)}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </div>

  const onDragEnd = (result) => {
    let [orderId, orderLineId] = result.draggableId.split('|');
    handleSwitchLineStatus(orderId, orderLineId, result.destination.droppableId);
  };


  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div>
        <div style={{display: 'flex'}}>
          {column('TODO')(unfilteredOLines)}
          {column('DOING')(unfilteredOLines)}
          {column('DONE')(unfilteredOLines)}
        </div>
        {unfilteredOLines.length < 1
          ? <p>
              No tienes trabajo pendiente, mi querido minion. 
              Enhorabuena, puedes ir al baño.
            </p>
          : ""}
      </div>
    </DragDropContext>

  );
};

const PendingOrderLinesComponent = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(PendingOrderLines);

export default PendingOrderLinesComponent;



// WEBPACK FOOTER //
// ./src/components/container/PendingOrderLines2.js